/**
 * @copyright (C) 2024, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * Soyun Lee (sylee2@rsupport.com)
 *
 * @description
 *
 * @created at Thu Jul 25 2024
 **/
import { Column, Typography } from "@/frameworks/designStuff/components";
import { _T } from "@rfice/language";

import * as S from "./private/emotion";
import { Avatar } from "@/frameworks/core/components";

export default function MyDeskKnockApply({
	userID,
	userName,
	message,
	time
}: {
	userID: string;
	userName: string;
	message: string;
	time: string;
}) {
	return (
		<S.Container horizonAlign="center" gap={16}>
			<Avatar id={userID} kind="people_80" showMiniProfile={false} />
			<Column gap={8} horizonAlign="center">
				<Typography typoColor="neutral_80_100" typoSize="Title2" style={{ whiteSpace: "pre-wrap" }}>
					{_T("마이데스크에 있는 {{userName}}님에게\n메시지가 왔습니다.", { userName })}
				</Typography>
				<Typography typoColor="neutral_50_100" typoSize="Body4">
					{time}
				</Typography>
			</Column>
			<S.MessageContainer verticalAlign="center" horizonAlign="center">
				<Typography typoColor="neutral_70_100" typoSize="Title1_B">
					{message}
				</Typography>
			</S.MessageContainer>
		</S.Container>
	);
}
